module.exports = __webpack_public_path__ + "img/emoji-sick-240x240.5abf896a.png";